import { TEMPO } from 'context/BrandContext';
import { getEnvConstants } from 'helpers/envConstants';

export const MILITARY_MEDICAL_TEACHER_SCOPES =
  'military,responder,nurse,medical,teacher,hospital_employee';
export const STUDENT_ALUMNI_GOV_SCOPES = 'student,alumni,government';

export const hideIdMe = (voucher, user) => {
  if (!voucher || !voucher.code) return false;
  return Boolean(user?.isUsaa || voucher?.isGovX || voucher?.hideIdMe);
};

export const endpointFor = ({
  brand,
  scopes,
  account = false,
  billing = false,
  family = false,
  isPickYourMeals = false,
}) => {
  const origin = window.location.origin;
  const { IDME_CLIENT_ID } = getEnvConstants(brand);
  let redirectUri;

  if (account) {
    redirectUri = `${origin}/account/settings/billing`;
  } else if (billing) {
    if (family) {
      redirectUri = `${origin}/signup/billing/family`;
    } else if (brand === TEMPO) {
      if (isPickYourMeals) {
        redirectUri = `${origin}/pick-meals/billing/tempo`;
      } else {
        redirectUri = `${origin}/signup/billing/tempo`;
      }
    } else {
      redirectUri = `${origin}/signup/billing/standard`;
    }
  } else {
    if (family) {
      redirectUri = `${origin}/signup/promo/family`;
    } else if (brand === TEMPO) {
      redirectUri = `${origin}/signup/promo/tempo`;
    } else {
      redirectUri = `${origin}/signup/promo/standard`;
    }
  }

  return `https://groups.id.me/?client_id=${IDME_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=token&scopes=${scopes}`;
};
